import React from 'react';
import ReactTable from 'react-table';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import EditAffiliateDialog from './edit-affiliate-dialog';
import CreateAffiliateDialog from './create-affiliate-dialog';
import FundraisingLinksButton from './fundraising-links-button';

/** @class AffiliateList
  * A component for displaying and editing affiliate groups.
  */
export default class AffiliateList extends ReactFireComponent {
  /** @constructor
    * Constructs a new ActiveUserList.
    */
  constructor(props) {
    super(props);
    this.state = {
      affiliates: [],
      selectedAffiliate: null,
      showNewDialog: false
    }
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.toggleNewDialog = this.toggleNewDialog.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to the active user list in
    * the firebase database.
    */
  componentWillMount(){
    this.bindAsArray(`/affiliates`, 'affiliates');
  }
  /** @method componentWillUnmount
    * Unbinds the component from the active user list
    * in the firebase database.
    */
  componentWillUnmount() {
    this.unbind('affiliates');
  }
  handleGroups(id) {
    this.setState({
      selectedAffiliate: null,
      affiliateGroups: id
    });
  }
  /** @method handleEdit
    * Allows the selection of an affiliate from the list to edit.
    * @param {string} id - the identity of the affiliate to edit
    */
  handleEdit(id) {
    this.setState({
      selectedAffiliate: id,
      affilateGroups: null
    });
  }
  /** @method handleRemove
    * Allows the removal of an affiliate from the list.
    * @param {string} id - the identifier of the affiliate
    */
  handleRemove(id) {
    if(window.confirm("Are you sure?  This will permanently remove them from the Vexpo Admin Platform.")) {
      firebase.database().ref(`/affiliates/${id}`).set(null);
    }
  }
  /** @method toggleNewDialog
    * Displays or hides the new affiliate dialog
    */
  toggleNewDialog() {
    this.setState({showNewDialog: !this.state.showNewDialog});
  }
  /** @method render
    * Renders the component
    */
  render() {
    const columns = [
      {Header: 'Organization', accessor: 'organization'},
      {Header: 'Group', accessor: 'group'},
      {Header: 'Token', accessor: 'token'},
      {Header: 'Category', accessor: 'category'},
      {Header: 'Contact Name', accessor: 'contact'},
      {Header: 'Contact Email', accessor: 'email', Cell: row => (
        <a href={`mailto://${row.value}`}>{row.value}</a>
      )},
      {Header: 'Contact Number', accessor: 'phone'},
      {Header: 'Fundrasing', accessor: 'token', Cell: row => (
        <FundraisingLinksButton token={row.value}/>
      )},
      {Header: '', accessor: 'id', Cell: row => (
        <div style={{textAlign:'right'}}>
          <FontAwesome name="edit"
            style={{color:'orange', cursor: 'pointer'}}
            onClick={() => this.handleEdit(row.value)}/>
          <FontAwesome name="times"
            style={{color:'red', cursor: 'pointer'}}
            onClick={() => this.handleRemove(row.value)}/>
        </div>
      ),
      filterable: false}
    ]
    const selectedAffiliate = this.state.affiliates.find(affiliate => {
      return affiliate.id === this.state.selectedAffiliate;
    });
    const editorDialog = selectedAffiliate
      ? <EditAffiliateDialog affiliate={selectedAffiliate} show={true} onExit={()=>{this.setState({selectedAffiliate: null})}} />
      : '';
    const style = {
      width: '100%'
    }
    const claimedTokens = this.state.affiliates.map((affiliate) => {
      return affiliate.token;
    });
    return (
      <div>
        <button className="btn btn-success" onClick={this.toggleNewDialog}>
          <FontAwesome name="plus"/>
          Add New Affiliate
        </button>
        <CreateAffiliateDialog
          show={this.state.showNewDialog}
          onExit={this.toggleNewDialog}
          claimedTokens={claimedTokens} />
        {editorDialog}
        <ReactTable
          className="-striped"
          data={this.state.affiliates}
          columns={columns}
          defaultPageSize={15}
          style={style}
          filterable
          />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/affiliate-list/affiliate-list.js